<!-- 验车信息 -->
<template>
  <div>
    <QS-h4-title title="验车信息" />
    <div class="upload-box">
      <p class="upload-box__title">
        车况照片
        <span class="sub-title-line">（可批量上传最多80张）</span>
      </p>
      <div class="upload-box__content">
        <UploadCommon
          :fileList="aboutCarImgsData"
          :limit="80"
          :multiple="true"
          :sizeType="4"
          fileTitle="最多上传80张"
          fileTitleWidth="240px"
          :isAlone="false"
          :showUploadBtnByLimit="80"
          commonUpload
          group="order"
          code="order_vehicle_pic"
        />
      </div>
    </div>
    <div class="upload-box">
      <p class="upload-box__title">
        验车交接文件照片
        <span class="sub-title-line">（可批量上传最多10张）</span>
      </p>
      <div class="upload-box__content">
        <UploadCommon
          :fileList="checkCarImgData"
          :limit="10"
          :multiple="true"
          :sizeType="4"
          fileTitle="最多上传10张"
          fileTitleWidth="240px"
          :isAlone="false"
          commonUpload
          group="vehicle"
          code="vehicle_inspection_file"
        />
      </div>
    </div>
    <div class="upload-box">
      <p class="upload-box__title">
        验车视频
        <span class="sub-title-line">（可批量上传最多5个，每个不超过100MB，支持mp4/mov/3gp等视频格式）</span>
      </p>
      <div class="upload-box__content">
        <UploadCommon
          :fileList="inspectionVideoPlus"
          :limit="5"
          :multiple="true"
          :sizeType="4"
          fileTitle="最多上传5个"
          fileTitleWidth="240px"
          :isAlone="false"
          listType="text"
          acceptType=".mp4,.mov,.3gp,.avi,.wmv,.flv,.mkv,.webm"
          commonUpload
          group="vehicle"
          code="vehicle_inspection_file"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    inspectionAttachment: {
      type: String,
      default: '',
    },
    photo: {
      type: String,
      default: '',
    },
    inspectionVideo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 验车交接文件:
      checkCarImgData: [],
      // 车辆相关照片
      aboutCarImgsData: [],
      // 验车视频
      inspectionVideoPlus: [],
    }
  },
  watch: {
    inspectionAttachment(val) {
      if (!val) return
      this.getCheckCarImgDataChange(val)
    },
    photo(val) {
      if (!val) return
      this.getAboutCarImgsData(val)
    },
    inspectionVideo(val) {
      if (!val) return
      this.getInspectionVideoData(val)
    },
  },
  methods: {
    // 从URL的key参数中提取文件名
    extractFileName(url) {
      if (!url) return ''
      try {
        const queryString = url.split('?')[1] || ''
        const params = new URLSearchParams(queryString)
        const key = params.get('key') || ''
        if (key) {
          return decodeURIComponent(key.split('/').pop() || '')
        }
        return decodeURIComponent(url.split('?')[0].split('/').pop() || '')
      } catch (e) {
        return ''
      }
    },
    // 回显验车交接文件
    getCheckCarImgDataChange(photo) {
      const parsePhoto = (photo && JSON.parse(photo)) || []
      const list = []
      parsePhoto?.forEach((item) => {
        item.urlList = this.getEchoUploadFileData(item?.urlList, true)
        if (Array.isArray(item.urlList) && item.urlList.length) {
          item.urlList.forEach((url) => {
            list.push({
              url,
            })
          })
        }
      })
      this.checkCarImgData = list
    },
    // 回显车辆相关照片
    getAboutCarImgsData(photo) {
      const parsePhoto = JSON.parse(photo)
      const list = []
      parsePhoto?.forEach((item) => {
        item.urlList = this.getEchoUploadFileData(item?.urlList, true)
        if (Array.isArray(item.urlList) && item.urlList.length) {
          item.urlList.forEach((url) => {
            list.push({
              url,
            })
          })
        }
      })
      this.aboutCarImgsData = list
    },
    // 回显验车视频
    getInspectionVideoData(data) {
      try {
        const list = typeof data === 'string' ? JSON.parse(data) : data
        if (Array.isArray(list)) {
          this.inspectionVideoPlus = list.map((item, i) => {
            if (typeof item === 'string') {
              return { url: item, name: this.extractFileName(item), uid: `video_${i}`, status: 'success' }
            }
            return { url: item.url || '', name: item.name || this.extractFileName(item.url || ''), uid: item.uid || `video_${i}`, status: 'success' }
          })
        }
      } catch (e) {
        this.inspectionVideoPlus = []
      }
    },
    // 获取验车信息数据
    // eslint-disable-next-line vue/no-unused-properties
    getCheckCarInfoData() {
      const obj = {}
      if (this.checkCarImgData.length) {
        const filterCheckCarImgData = [{
          remark: '',
          urlList: this.checkCarImgData.map((item) => item.url),
        }]
        obj.inspectionAttachment = JSON.stringify(filterCheckCarImgData)
      } else {
        obj.inspectionAttachment = ''
      }
      if (this.aboutCarImgsData.length) {
        const filterAboutCarImgsData = [{
          remark: '',
          urlList: this.aboutCarImgsData.map((item) => item.url),
        }]
        obj.photo = JSON.stringify(filterAboutCarImgsData)
      } else {
        obj.photo = ''
      }
      if (this.inspectionVideoPlus.length) {
        obj.inspectionVideo = this.inspectionVideoPlus.map((item) => item.url)
      } else {
        obj.inspectionVideo = []
      }
      return obj
    },
  },
}
</script>

<style scoped lang="scss">
.car-details {
  height: 100%;

  .item,
  .info,
  .dialogwrap-add {
    ::v-deep .el-input--small {
      width: 205px;
    }
  }

  .float-right {
    float: right;
  }

  .sumbit-btns {
    text-align: center;
  }
}

.fileUpload {
  display: flex;

  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
    color: #333;
  }
}

.photoUpload {
  margin-top: 15px;
  display: flex;

  .txt {
    padding-right: 12px;
    width: 149px;
    box-sizing: border-box;
    text-align: right;
  }
}

.imgList {
  padding-right: 12px;
  box-sizing: border-box;
  text-align: right;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 30px;

  .imgList_summay {
    display: flex;
    align-items: flex-start;
  }
}
</style>
